import { Col, Form, Input, Row, Spin } from 'antd';
import { DetailProduct, Products } from '../../Inbound/Interface';
import { Image } from 'antd';
function DetailsProductForm({
  data,
  edit
}: {
  data?: DetailProduct[];
  edit?: boolean;
}) {
  const isEdit = edit ? false : true;
  const inforForm = (detailProduct: Products, index: number) => {
    return (
      <div style={{ background: '#F9F9F9', margin: '10px 0' }} key={index}>
        <Form
          layout="vertical"
          style={{
            padding: '19px 0px',
            width: '95%',
            margin: 'auto'
          }}
          initialValues={{
            productName: detailProduct ? detailProduct.productName : '',
            width: detailProduct ? detailProduct.width : '',
            length: detailProduct ? detailProduct.length : '',
            height: detailProduct ? detailProduct.height : '',
            demensionUnit: detailProduct ? detailProduct.demensionUnit : '',
            weight: detailProduct ? detailProduct.weight : '',
            weightUnit: detailProduct ? detailProduct.weightUnit : '',
            estimateQuantity: detailProduct
              ? detailProduct.estimateQuantity
              : '',
            averageMonthSale: detailProduct
              ? detailProduct.averageMonthSale
              : '',
            sku: detailProduct ? detailProduct.sku : '',
            eanUpc: detailProduct ? detailProduct.eanUpc : '',
            asin: detailProduct ? detailProduct.asin : '',
            packedMethod: detailProduct ? detailProduct.packedMethod : '',
            storageMethod: detailProduct ? detailProduct.storageMethod : '',
            dangerousGoods: detailProduct ? detailProduct.dangerousGoods : '',
            lotProduct: detailProduct ? detailProduct.lotProduct : ''
          }}
        >
          <Row gutter={24}>
            <Col span={7}>
              <div className="productImg">
                <Image
                  preview={false}
                  src={
                    detailProduct?.image?.url
                      ? detailProduct?.image?.url
                      : '/images/nophoto.jpg'
                  }
                  style={{
                    width: '100%'
                  }}
                />
              </div>
            </Col>
            <Col span={16}>
              <Row>
                <Col span={8}>
                  <Form.Item
                    label="Product Name"
                    style={{
                      display: 'inline-block',
                      marginRight: '50px',
                      width: '90%'
                    }}
                    name="productName"
                  >
                    <Input disabled={isEdit} className="inputRadious" />
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="Dimensions (Based on unit package)"
                    style={{
                      display: 'inline-block',
                      width: '100%'
                    }}
                  >
                    <Form.Item
                      name="width"
                      style={{
                        width: '25%',
                        padding: '0 10px',
                        marginBottom: '20px',
                        display: 'inline-block'
                      }}
                    >
                      <Input
                        disabled={isEdit}
                        suffix="Width"
                        className="inputRadious"
                      />
                    </Form.Item>
                    <Form.Item
                      name="length"
                      style={{
                        width: '25%',
                        padding: '0 10px',
                        marginBottom: '20px',
                        display: 'inline-block'
                      }}
                    >
                      <Input
                        disabled={isEdit}
                        suffix="Length"
                        className="inputRadious"
                      />
                    </Form.Item>
                    <Form.Item
                      name="height"
                      style={{
                        width: '25%',
                        padding: '0 10px',
                        marginBottom: '20px',
                        display: 'inline-block'
                      }}
                    >
                      <Input
                        disabled={isEdit}
                        suffix="Height"
                        className="inputRadious"
                      />
                    </Form.Item>
                    <Form.Item
                      name="demensionUnit"
                      style={{
                        width: '20%',
                        padding: '0 0 0 10px',
                        marginBottom: '20px',
                        display: 'inline-block'
                      }}
                    >
                      <Input disabled={isEdit} className="inputRadious" />
                    </Form.Item>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={10}>
                  <Form.Item
                    label="Weight"
                    style={{ display: 'inline-block', width: '100%' }}
                  >
                    <Form.Item
                      name="weight"
                      style={{
                        width: '65%',
                        display: 'inline-block',
                        marginRight: 10
                      }}
                    >
                      <Input disabled={isEdit} className="inputRadious" />
                    </Form.Item>
                    <Form.Item
                      name="weightUnit"
                      label=""
                      style={{ width: '30%', display: 'inline-block' }}
                    >
                      <Input disabled={isEdit} className="inputRadious" />
                    </Form.Item>
                  </Form.Item>
                </Col>
                <Col span={7}>
                  <Form.Item
                    label="Estimated Quantity"
                    name="estimateQuantity"
                    style={{ width: '95%' }}
                  >
                    <Input disabled={isEdit} className="inputRadious" />
                  </Form.Item>
                </Col>
                <Col span={7}>
                  <Form.Item
                    label="Average Monthly Sale"
                    name="averageMonthSale"
                  >
                    <Input disabled={isEdit} className="inputRadious" />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Form.Item
                  label="SKU"
                  name="sku"
                  style={{ width: '32%', marginRight: '20px' }}
                >
                  <Input disabled={isEdit} className="inputRadious" />
                </Form.Item>
                <Form.Item
                  label="EAN/UPC"
                  name="eanUpc"
                  style={{ width: '32%', marginRight: '20px' }}
                >
                  <Input disabled={isEdit} className="inputRadious" />
                </Form.Item>
                <Form.Item label="ASIN" name="asin" style={{ width: '32%' }}>
                  <Input disabled={isEdit} className="inputRadious" />
                </Form.Item>
              </Row>
              <Row>
                <Form.Item
                  label="Packing Method"
                  name="packedMethod"
                  style={{ width: '25%', padding: '0 10px 0 0' }}
                >
                  <Input disabled={isEdit} className="inputRadious" />
                </Form.Item>
                <Form.Item
                  label="Storage Method"
                  name="storageMethod"
                  style={{ width: '25%', padding: '0 10px' }}
                >
                  <Input disabled={isEdit} className="inputRadious" />
                </Form.Item>
                <Form.Item
                  label="Dangerous Goods"
                  name="dangerousGoods"
                  style={{ width: '25%', padding: '0 10px' }}
                >
                  <Input disabled={isEdit} className="inputRadious" />
                </Form.Item>
                <Form.Item
                  label="Lot Product"
                  name="lotProduct"
                  style={{ width: '25%', padding: '0 0 0 10px' }}
                >
                  <Input disabled={isEdit} className="inputRadious" />
                </Form.Item>
              </Row>
            </Col>
          </Row>
        </Form>
      </div>
    );
  };
  return (
    <>
      {data
        ? data?.map((product: any, index: number) => inforForm(product, index))
        : inforForm()}
    </>
  );
}

export default DetailsProductForm;
